<section class="terms terms-of-use" id="page">
		<app-term-he *ngIf="local_id === 'he'"></app-term-he>
		<app-term-en *ngIf="local_id !== 'he'"></app-term-en>
</section>
